<div class="quiz-question">
  <div class="quiz-question__close-button">
    <app-enfaf-icon svgIconName="x-blue" iconSize="24px" [isButton]="true" (onClick)="close.emit()"></app-enfaf-icon>
  </div>

  <div class="quiz-question__body">
    <div class="quiz-question__statement">{{ questionNumber() }}. {{ question().statement }}</div>

    <div class="quiz-question__options">
      <mat-radio-group [value]="pendingSelection()">
        @for (option of question().options; track question().quizQuestionId + ':' + $index; let i = $index) {
        <div class="quiz-question__option-card" (click)="onSelectOption(i)">
          <mat-radio-button [value]="i" class="quiz-question__option">
            {{ option }}
          </mat-radio-button>
        </div>
        }
      </mat-radio-group>
    </div>
  </div>

  <div class="quiz-question__actions">
    <div class="actions-left">
      <app-circular-progress class="quiz-question__circular-progress" [percentage]="progressPercent()"
        [showCheckIcon]="false"></app-circular-progress>
      <div class="quiz-question__progress-texts">
        <span>{{ answeredCount() }}/{{ totalQuestions() }} respondidas</span>
      </div>
    </div>
    <div class="actions-right">
      <app-enfaf-button type="modal-outline" (click)="onGoBack()">Atrás</app-enfaf-button>
      <app-enfaf-button type="modal-primary" [disabled]="pendingSelection() === null || isSubmitting()"
        (click)="onSubmit()">{{
        questionNumber() === totalQuestions() ? 'Finalizar' : 'Siguiente'
        }}</app-enfaf-button>
    </div>
  </div>
</div>